<dx-popup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="65%"
    title="Manage Bookmark"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onHiding)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="popup-favourite-box cc-popup-favourite-box">
            <dxi-item [ratio]="1">
                <dx-box width="100%" height="100%" direction="row" class="tree-box">
                    <dxi-item [ratio]="1">
                        <div class="tree-panel dx-theme-border-color">
                            <div class="tree-header dx-theme-border-color">
                                <div class="header">
                                    <i class="far fa-star header-icon"></i>
                                    Views
                                </div>
                                <div class="tree-icon-cursor">
                                    <i [class]="navTreeExpanCollapseIcon" (click)="toggleNavViewTreeExpansion()"></i>
                                </div>
                            </div>
                            <dx-sortable
                                filter=".dx-treeview-item"
                                group="shared"
                                data="active"
                                width="100%"
                                height="100%"
                                [allowReordering]="false"
                                (onDragChange)="onDragChange($event)"
                                (onDragEnd)="onDragEnd($event)"
                            >
                                <dx-tree-view
                                    #treeviewNav
                                    id="treeviewNav"
                                    class="tree-view"
                                    dataStructure="plain"
                                    itemTemplate="itemTemplate"
                                    width="100%"
                                    height="90%"
                                    selectionMode="single"
                                    [focusStateEnabled]="true"
                                    [expandNodesRecursive]="false"
                                    [items]="navItems"
                                >
                                    <div *dxTemplate="let item of 'itemTemplate'">
                                        <div class="tree-item-container">
                                            <div class="tree-icon" [ngClass]="{ 'tree-disabled': item.bookmarked }">
                                                <i [class]="item.icon"></i>
                                            </div>
                                            <div class="tree-label" [ngClass]="{ 'tree-disabled': item.bookmarked }">
                                                {{ item.text }}
                                            </div>
                                        </div>
                                    </div>
                                </dx-tree-view>
                            </dx-sortable>
                        </div>
                    </dxi-item>

                    <dxi-item [ratio]="1">
                        <div class="tree-panel-right">
                            <div class="tree-header dx-theme-border-color">
                                <div class="header">
                                    <i class="fas fa-star header-icon"></i>
                                    Bookmarks
                                </div>
                                <div class="tree-icon-cursor">
                                    <i
                                        [class]="bookmarkTreeExpandCollapseIcon"
                                        (click)="toggleBookmarkTreeExpansion()"
                                    ></i>
                                </div>
                                <div class="tree-icon-cursor close-icon">
                                    <i class="far fa-window-close" (click)="removeAllBookmark()"></i>
                                </div>
                            </div>
                            <dx-sortable
                                filter=".dx-treeview-item"
                                class="tree-view"
                                group="shared"
                                data="bookmarked"
                                width="100%"
                                height="100%"
                                [allowDropInsideItem]="true"
                                [allowReordering]="true"
                                (onDragChange)="onDragChange($event)"
                                (onReorder)="onReorderChange($event)"
                            >
                                <dx-tree-view
                                    #treeviewBookmarked
                                    id="treeviewBookmarked"
                                    dataStructure="plain"
                                    itemTemplate="itemTemplate"
                                    width="100%"
                                    height="90%"
                                    selectionMode="single"
                                    [selectByClick]="true"
                                    [expandNodesRecursive]="false"
                                    [items]="bookmarkedItems"
                                >
                                    <div *dxTemplate="let item of 'itemTemplate'">
                                        <div class="tree-item-container">
                                            <div class="tree-icon" [ngClass]="{ 'tree-disabled': item.disable }">
                                                <i [class]="item.icon"></i>
                                            </div>
                                            <div class="tree-label" [ngClass]="{ 'tree-disabled': item.disable }">
                                                {{ item.text }}
                                            </div>
                                            <div *ngIf="item.selected" class="tree-icon-cursor">
                                                <i [ngClass]="iconClose" (click)="removeBookmark(item)"></i>
                                            </div>
                                        </div>
                                    </div>
                                </dx-tree-view>
                            </dx-sortable>
                        </div>
                    </dxi-item>
                </dx-box>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onBookmarkClose($event)"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    [icon]="iconSave"
                                    (onClick)="onBookmarkSave($event)"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
